import './CertificatePaymentPreviewModal.scss'
import React, { FC } from 'react'
import { Modal } from 'react-bootstrap'
import CertificatePaymentPreview from '../CertificatePaymentPreview/CertificatePaymentPreview';
import { ICertificatePaymentPreview } from 'app_types/user/certificateTypes';


interface ICertificatePaymentPreviewModal {
  open: boolean
  onClose: () => void
  data?: ICertificatePaymentPreview
}

const CertificatePaymentPreviewModal: FC<ICertificatePaymentPreviewModal> = ({open, onClose, data}) => {
  return (
    <Modal
      show={open}
      onHide={onClose}
      backdrop="static"
      keyboard={false}
      dialogClassName='certificate-payment-preview-modal--dialog'
    >
      <Modal.Body>
        {!!data && (
          <CertificatePaymentPreview data={data} onClose={onClose}/>
        )}
      </Modal.Body>
    </Modal>

  )
}

export default CertificatePaymentPreviewModal
